// import * as constants from 'admin/constants';
/**
 * Attaches a bearer json web token to the Authorization request header
 * @param {object} req
 * @return {object} request object
 */
export function attachJwtToken(req) {
	// req.set('Authorization', `Bearer ${localStorage.getItem(constants.common.USER_TOKEN_ID)}`);

	return req;
}
